import { Typography } from "@mui/joy";

export const Paragraph = (props) => (
  <Typography level="body-sm" sx={{ marginBottom: "1rem" }} {...props} />
);
